import { render, staticRenderFns } from "./billsToReceive.vue?vue&type=template&id=a5fa743e&scoped=true&"
import script from "./billsToReceive.vue?vue&type=script&lang=js&"
export * from "./billsToReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa743e",
  null
  
)

export default component.exports